import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: {
      main: "#6f3e8f",
      light: "#8a5cab",
      dark: "#4f216c",
      contrastText: "#ffffff",
    },
    secondary: {
      main: "#13839b",
      light: "#35a8bd",
      dark: "#075d70",
      contrastText: "#ffffff",
    },
    success: {
      main: "#258558",
    },
    warning: {
      main: "#f2b84b",
    },
    error: {
      main: "#c94343",
    },
    background: {
      default: "#f5f8fb",
      paper: "#ffffff",
    },
    text: {
      primary: "#263238",
      secondary: "#5d7078",
    },
  },
  shape: {
    borderRadius: 8,
  },
  typography: {
    fontFamily: [
      "Ubuntu Sans",
      "Segoe UI",
      "Roboto",
      "Arial",
      "sans-serif",
    ].join(","),
    h1: { fontWeight: 800 },
    h2: { fontWeight: 800 },
    h3: { fontWeight: 800 },
    h4: { fontWeight: 800 },
    h5: { fontWeight: 800 },
    h6: { fontWeight: 800 },
    button: {
      fontWeight: 700,
      textTransform: "none",
    },
  },
  components: {
    MuiButton: {
      defaultProps: {
        disableElevation: true,
      },
      styleOverrides: {
        root: {
          borderRadius: 8,
          minHeight: 40,
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          borderColor: "#dfe8ee",
        },
      },
    },
    MuiDialog: {
      styleOverrides: {
        paper: {
          borderRadius: 8,
        },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        head: {
          color: "#455a64",
          fontWeight: 800,
          backgroundColor: "#f3f6f8",
        },
      },
    },
    MuiTextField: {
      defaultProps: {
        variant: "outlined",
      },
    },
  },
});

export default theme;
